/* eslint-disable comma-dangle */
/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import Router from 'vue-router';
import Meta from 'vue-meta';

// Routes
import { appRedirects, appRoutes } from '../navigation';

function route(path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta,
    component: resovle => import(
      `@/views/${view}.vue`
    ).then(resovle)
  };
}
Vue.use(Router);
const parsedRoutes = appRoutes.map(path => route(path.path, `${path.view}`, path.name, path.meta));
const routes = [...parsedRoutes, ...appRedirects];

// Create a new router
const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

Vue.use(Meta);

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development',
    },
  });
}

export default router;
